import { http, ep } from '../../client/http';

export const contactRepo = {
  get: async () => {
    const res = await http.get(ep('contact'));
    return res.data.data; // <-- artık direkt {logo, favicon, ...} döner
  }
};
